import { Grid, Paper } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Breadcrumb from "../../App/Components/Navigation/Subcomponents/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../App/Components/PageContainer/PageContainer";
import { PageTitle } from "../../App/Components/PageTitle/PageTitle";
import TabGroup from "../../App/Components/TabGroup/TabGroup";
import { ITabGroupConfig } from "../../App/Typings/TabPanel";
import { DisplayEmailTemplates } from "./Email/EmailTemplates";
import { DisplayTextTemplates } from "./Text/TextTemplates";

const emailTabLabel = "Email Templates";
const textTabLabel = "Text Templates";

export default function CommunicationTemplates() {
  const { tabLabel, handleTabChange } = useTemplatesTabsState();

  const tabGroupConfig: ITabGroupConfig = {
    groupLabel: "Message Templates",
    id: "message-center-tabs",
    currentTabState: tabLabel,
    fullWidth: false,
    changeTabState: (label) => {
      const tab = label === emailTabLabel ? "email" : "text";
      handleTabChange(tab);
    },
    tabs: [
      {
        label: emailTabLabel,
        TabComponent: <DisplayEmailTemplates />,
      },
      {
        label: textTabLabel,
        TabComponent: <DisplayTextTemplates />,
      },
    ],
  };

  return (
    <PageContainer>
      <Grid container>
        <Grid item xs={12}>
          <Breadcrumb pageTitle="Communication Templates" />
        </Grid>
      </Grid>
      <Paper sx={{ mt: { xs: 1, md: 2 }, p: { xs: 2, lg: 4 }, flex: 1 }}>
        <Grid container>
          <Grid item xs={12} sx={{ marginBottom: "10px" }}>
            <PageTitle sx={{ lineHeight: 1 }}>Communication Templates</PageTitle>
          </Grid>
        </Grid>
        <TabGroup config={tabGroupConfig} />
      </Paper>
    </PageContainer>
  );
}

function useTemplatesTabsState() {
  const [search, setSearch] = useSearchParams();
  const [currentTab, setCurrentTab] = useState<"email" | "text" | null>(
    (search.get("tab") as "email" | "text" | null) || "email",
  );
  const [tabLabel, setCurrentTabLabel] = useState(currentTab === "email" ? emailTabLabel : textTabLabel);

  function handleTabChange(newTab: "email" | "text") {
    setCurrentTabLabel(newTab === "email" ? emailTabLabel : textTabLabel);
    setCurrentTab(newTab);
    setSearch({ tab: newTab });
  }

  return {
    tabLabel,
    handleTabChange,
  } as const;
}
